var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLoyalty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5283 3.5999C15.7686 3.29437 16.2314 3.29437 16.4717 3.5999L18.7403 6.48534C18.8907 6.67656 19.1416 6.75808 19.3756 6.69175L22.907 5.69087C23.2809 5.58489 23.6554 5.85697 23.6702 6.24535L23.8095 9.9132C23.8188 10.1563 23.9739 10.3697 24.2022 10.4536L27.6474 11.7196C28.0123 11.8536 28.1553 12.2939 27.9389 12.6167L25.8958 15.666C25.7604 15.8681 25.7604 16.1319 25.8958 16.334L27.9389 19.3833C28.1553 19.7061 28.0123 20.1464 27.6474 20.2804L24.2022 21.5464C23.9739 21.6303 23.8188 21.8437 23.8095 22.0868L23.6702 25.7546C23.6554 26.143 23.2809 26.4151 22.907 26.3091L19.3756 25.3082C19.1416 25.2419 18.8907 25.3234 18.7403 25.5147L16.4717 28.4001C16.2314 28.7056 15.7686 28.7056 15.5283 28.4001L13.2597 25.5147C13.1093 25.3234 12.8584 25.2419 12.6244 25.3082L9.09299 26.3091C8.71906 26.4151 8.34457 26.143 8.32982 25.7546L8.19045 22.0868C8.18122 21.8437 8.02614 21.6303 7.79783 21.5464L4.35256 20.2804C3.98774 20.1464 3.8447 19.7061 4.06105 19.3833L6.10421 16.334C6.23961 16.1319 6.23961 15.8681 6.10421 15.666L4.06105 12.6167C3.8447 12.2939 3.98774 11.8536 4.35256 11.7196L7.79783 10.4536C8.02614 10.3697 8.18122 10.1563 8.19045 9.9132L8.32982 6.24535C8.34457 5.85697 8.71906 5.58489 9.09299 5.69087L12.6244 6.69175C12.8584 6.75808 13.1093 6.67656 13.2597 6.48534L15.5283 3.5999Z",
    stroke: "#020617",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16L14.6667 18.6667L20 13.3333",
    stroke: "#020617",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoyalty);
export default __webpack_public_path__ + "static/media/icon-loyalty.434f9b93f78bb1545a2d9326eeb0d0ca.svg";
export { ForwardRef as ReactComponent };